import axios from "axios";
import AppConstant from "../assets/js/AppConstant";

export const UpdateProposalTicketStatus = async ({
  ticketId,
  review,
  approver,
  isSkipValidateApprover,
  isTicketV2,
}) => {

  let url = `/marketing-claim-api/v1/ticket/${ticketId}/proposal-review`;
  if(isTicketV2){
    url = `/marketing-claim-api/v2/ticket/${ticketId}/proposal-review`;
    isSkipValidateApprover = true;
  }

  const payload = {
    reviews: review,
    is_skip_validate_approvers: isSkipValidateApprover,
    ...(isSkipValidateApprover ? {} : { approvers: approver }),
  };

  return await axios.post(AppConstant.MAIN_URL + url, payload );
};
